function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#A5ACB0",
  d: "M30 69h2V49h-2zM36 71h2V49h-2zM42 71h2V49h-2zM48 69h2V49h-2z"
}), React.createElement("path", {
  d: "M28 39c-2.206 0-4-1.794-4-4s1.794-4 4-4v2c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2h2c0 2.206-1.794 4-4 4M52 39c-2.206 0-4-1.794-4-4h2c0 1.103.897 2 2 2s2-.897 2-2-.897-2-2-2v-2c2.206 0 4 1.794 4 4s-1.794 4-4 4",
  fill: "#EA7125"
}), React.createElement("path", {
  fill: "#EA7125",
  d: "M28 33h24v-2H28zM28 29h24v-2H28zM50 45h-2c0-2.206 1.794-4 4-4v2c-1.103 0-2 .897-2 2M32 45h-2c0-1.103-.897-2-2-2v-2c2.206 0 4 1.794 4 4M44 45h-2c0-1.103-.897-2-2-2s-2 .897-2 2h-2c0-2.206 1.794-4 4-4s4 1.794 4 4M28 47h24v-2H28zM38 37h4v-2h-4zM36 39h-2c0-2.206 1.794-4 4-4v2c-1.103 0-2 .897-2 2M46 39h-2c0-1.103-.897-2-2-2v-2c2.206 0 4 1.794 4 4"
}), React.createElement("path", {
  fill: "#EA7125",
  d: "M39 42h2v-6h-2z"
}), React.createElement("path", {
  d: "M40 10c-16.542 0-30 13.458-30 30s13.458 30 30 30 30-13.458 30-30-13.458-30-30-30zm0 62C22.355 72 8 57.645 8 40S22.355 8 40 8s32 14.355 32 32-14.355 32-32 32z",
  fill: "#A5ACB0"
}), React.createElement("path", {
  d: "M24.404 60.805C17.792 55.841 14 48.258 14 40c0-14.337 11.664-26 26-26s26 11.663 26 26c0 8.256-3.791 15.838-10.399 20.802l-1.202-1.6C60.501 54.62 64 47.621 64 40c0-13.233-10.767-24-24-24S16 26.767 16 40c0 7.623 3.501 14.623 9.605 19.205l-1.201 1.6",
  fill: "#A5ACB0"
}), React.createElement("path", {
  d: "M0 0h80v80H0z"
}));

var SvgIconIllustrationPillar = function SvgIconIllustrationPillar(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80"
  }, props), _ref);
};

export default SvgIconIllustrationPillar;